import React, { useState, useEffect, useRef } from "react";
import "./OpalScrollSpy.css";
import TauriImage from "../TauriImage/TauriImage";
import TruncatedText from "../OpalCoverageLayout/CoverageView/OpalReminder/TruncateText/TruncateText";

const OpalScrollSpy = ({ reminders, asc = true }) => {

    const [groupedReminders, setGroupedReminders] = useState({});

    const formatDate = (dateStr) => {
        if (!dateStr) return null;

        // Parse only the date part to avoid timezone shifts
        const [year, month, day] = dateStr.split("T")[0].split("-");
        const date = new Date(Number(year), Number(month) - 1, Number(day));

        return date.toLocaleDateString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    };

    // Helper function to group reminders by date
    const groupRemindersByDate = (data) => {
        const map = reminders.reduce((acc, item) => {
            const key = item.Date.split("T")[0];
            (acc[key] ||= []).push(item);
            return acc;
        }, {});

        const sortedEntries = Object.entries(map).sort(([a], [b]) => {
            const dateA = new Date(a);
            const dateB = new Date(b);
            return asc ? dateA - dateB : dateB - dateA;
        });

        return Object.fromEntries(sortedEntries);
    };

    useEffect(() => {
        const grouped = groupRemindersByDate(reminders);
        setGroupedReminders(grouped);
    }, [reminders, asc]);

    const [selectedDateIndex, setSelectedDateIndex] = useState(0);
    const containerRef = useRef(null);
    const itemRefs = useRef([]);

    useEffect(() => {
        const handleScroll = () => {
            const containerTop = containerRef.current.getBoundingClientRect().top;

            const visibleIndex = itemRefs.current.findIndex((ref) => {
                if (!ref) return false;
                const rect = ref.getBoundingClientRect();
                return rect.top - containerTop >= 0 && rect.top - containerTop < 100;
            });

            if (visibleIndex !== -1 && visibleIndex !== selectedDateIndex) {
                setSelectedDateIndex(visibleIndex);
            }
        };

        const container = containerRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
            return () => container.removeEventListener("scroll", handleScroll);
        }
    }, [selectedDateIndex]);

    const handleClick = (index) => {
        setSelectedDateIndex(index);
        itemRefs.current[index]?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <div className="reminder-scroll-spy">
            {/* Sidebar Nav */}
            <nav className="nav position-sticky d-none d-md-block">
                {Object.keys(groupedReminders).map((date, index) => (
                    <button
                        key={index}
                        className={`nav-link text-start btn btn-link ${index === selectedDateIndex ? "selected" : ""}`}
                        onClick={() => handleClick(index)}
                        style={{ textDecoration: "none" }}
                    >
                        {formatDate(date)}
                    </button>
                ))}
            </nav>

            {/* Scrollable Content */}
            <div
                className="scrollable-content"
                ref={containerRef}
                tabIndex="0"
            >
                {Object.entries(groupedReminders).map(([date, group], index) => (
                    <div
                        key={index}
                        ref={(el) => (itemRefs.current[index] = el)}
                        className="mb-4"
                    >
                        <div className="date-display">{formatDate(date)}</div>

                        {group.map((item, idx) => (
                            <div
                                key={idx}
                                className="note-item d-flex align-items-start p-2"
                                style={{ backgroundColor: idx % 2 === 0 ? '#F8F8F8' : '#FFFFFF' }}
                            >
                                <TauriImage
                                    localImage={"/Images/akar-icons--bell.svg"}
                                    className="note-icon me-3"
                                    color="#000000"
                                    alt="icon"
                                />
                                <div>
                                    <TruncatedText text={item?.Message} maxLength={100} />
                                </div>
                            </div>
                        ))}

                    </div>
                ))}
            </div>
        </div>
    );
};

export default OpalScrollSpy;
